import React from "react";
import { observer } from "mobx-react";
import { errorExplanationOptions, getInputRenderingInfo, addCalculationToResponses } from '../helpers'
import store from './Stores/SurveyStore'
import {
    Tooltip,
} from 'react-tippy';
import { getSurveyResponseValue } from "../Helpers/General/SurveyResponsesHelper";
import { formatNumber } from "../Helpers/General/FormatHelper";

const SurveyCalculatedField = observer((props) => {
    //needs formating   also
    var separators = ['\\\+', '-', '\\\(', '\\\)', '\\*', '/', ':', '\\\?'];
    var code = props.formula;
    var inputRenderingInfo = getInputRenderingInfo(props.name)
 
    try {
        var formulaItems = code.split(new RegExp(separators.join('|'), 'g'));
        formulaItems.forEach(function (entry) {
            var formulaItem = entry.replace("[", "").replace("]", "").trim()
            var val = getSurveyResponseValue(formulaItem, null);
            val = val.toString().replace(",", "");
            
            if (val != "" && Math.sign(val) == -1) val = "(" +val+ ")";
            //if the value is a non number (please confirm)
            if (store.local.naList.includes(val) || store.local.unknownList.includes(val) || val=="" || val==undefined) {
                val = 0;
            }
            //replace val in the actual formula
            code = code.replace(entry, val)
        });

        code = code.trim()
        var calculatedVal;

        calculatedVal = eval(code)
        var calcClassName = " calculatedField";
        calcClassName += props.isWidePlanInfo ? " widePlanInfo" : "";

        var textInputValue;
        if (store.questionMode) {
            textInputValue = props.name
        }

        else {
            if (Math.sign(calculatedVal) == -1) {
                textInputValue = "(" + formatNumber(props.format, Math.abs(calculatedVal)) + ")";
            } else {
                textInputValue = formatNumber(props.format, calculatedVal);
            }

            addCalculationToResponses(props.name, calculatedVal)
        }

    } catch (err) {
        textInputValue = "Err"

        var calcClassName = " calculatedField";
        calcClassName += props.isWidePlanInfo ? " widePlanInfo" :"";
    }

    const renderCalculationField = () => {
        return (
            <div title={(props.formula && store.questionMode) ? props.name + " = " + props.formula : ""}>


                <input className={calcClassName + inputRenderingInfo.textClassName + inputRenderingInfo.inputColor} value={textInputValue}></input>
                {
                    props.helpText &&
                    <Tooltip
                        position="right"
                        trigger="mouseenter"
                        animation="fade"
                        arrow="true"
                        size="small"
                        interactive="true"
                        hideOnClick="false"
                        html={(
                            <div className="genericTooltip">
                                {props.helpText}
                            </div>
                        )}
                    >
                        <i className="fas fa-info-circle fa-xs" ></i>
                    </Tooltip>

                }

            </div >
        )
    }

    if (props.helpText) calcClassName = calcClassName + " noRightMargin"
    return (
        <React.Fragment> 

            {inputRenderingInfo && inputRenderingInfo.feedbackComment &&
                <Tooltip
                    disabled={store.questionMode}
                    position="top"
                    trigger="mouseenter"
                    animation="fade"
                    arrow="true"
                    delay={250}
                    size="small"
                    interactive="true"
                    hideOnClick="false"
                    html={(
                       <div className="genericTooltip">
                            {inputRenderingInfo.feedbackComment}<br />
                            {errorExplanationOptions(props.name, inputRenderingInfo, textInputValue)}

                        </div>
                    )}
            >

                {renderCalculationField()}
 
                </Tooltip>
            }

            {inputRenderingInfo==undefined || !inputRenderingInfo.feedbackComment &&
                 renderCalculationField()
            }

        </React.Fragment>

    );

});
export default SurveyCalculatedField;

